import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';

let nextSectionId = 0;

@Component({
    selector: 'qpx-filter-section',
    templateUrl: './filter-section.html',
    styleUrl: './filter-section.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.aria-labelledby]': 'headingId()',
        '[attr.data-filter-section]': 'sectionKey()',
        role: 'region',
    },
})
export class QpxFilterSection {
    //#region Inputs
    public readonly sectionKey = input.required<string>();
    public readonly label = input.required<string>();
    public readonly summary = input<string | null>(null);
    //#endregion

    //#region State
    private readonly sectionId = nextSectionId++;
    protected readonly headingId = computed(
        () =>
            `qpx-filter-section-${this.sectionId}-${this.sectionKey()}-heading`
    );
    //#endregion
}
